/* eslint-disable react/jsx-pascal-case */
import { memo, useEffect, useRef } from 'react'
import TableCell from '@material-ui/core/TableCell'
import Typography from '@material-ui/core/Typography'
import { HtmlToolTip } from 'assets/ToolTips'
import { makeStyles, createStyles } from '@material-ui/core/styles'
import { baseStyle } from 'assets/TableHeader'

type Props = {
  caption?: boolean
  title?: boolean | React.ReactChild | React.ReactFragment | React.ReactPortal
  data?: boolean | React.ReactChild | React.ReactFragment | React.ReactPortal
  width?: number | string
  refs?: React.RefObject<HTMLTableCellElement>[]
  refIndex?: number
  align?: 'inherit' | 'left' | 'center' | 'right' | 'justify' | undefined
  click?: React.MouseEventHandler<HTMLSpanElement> | undefined
  focus?: boolean
  left?: number
  blackout?: boolean // マニュアル作成用に非表示対象を黒塗りする処理
  color?: string
}

const useStyles = makeStyles(() =>
  createStyles({
    hidden: {
      backgroundColor: 'inherit',
    },
    fixed: (props: { left?: number }) => ({
      position: 'sticky',
      backgroundColor: 'inherit',
      left: props.left,
      zIndex: 1,
    }),
  }),
)

// const tooltipDelay = 1000 // ツールチップが表示されるまでの長押し時間

/**
 * 幅をpx指定する場合はこちら
 * @param param0
 * @returns
 */
const A_TableCellText = ({ caption = true, title, data, width = 30, align = 'center', click = () => {}, focus = false, refs, refIndex = 0, left = undefined, blackout = false, color = 'none' }: Props) => {
  useEffect(() => {
    if (focus) {
      ref.current?.focus()
    }
  }, [focus])

  const classes = useStyles({ left: left })
  const ref = useRef<HTMLInputElement>(null)

  const style = { ...baseStyle, minWidth: width, backgroundColor: color }
  const leftClass = left != null ? classes.fixed : undefined

  return (
    <TableCell style={style} className={leftClass} align={align} onClick={click} ref={refs ? refs[refIndex] : undefined}>
      {caption ? (
        <HtmlToolTip
          title={
            <Typography variant="caption" color="inherit" style={{ whiteSpace: 'pre-wrap' }}>
              {title}
            </Typography>
          }
          enterTouchDelay={1500}
          leaveTouchDelay={10000}
          interactive={true}
          placement="bottom" // 下表示に統一
          arrow={true}
        >
          <Typography variant="caption" style={blackout ? { backgroundColor: 'black' } : {}}>
            {data}
          </Typography>
        </HtmlToolTip>
      ) : (
        <Typography variant="caption">{data}</Typography>
      )}
    </TableCell>
  )
}

export default memo(A_TableCellText)
